import {
  Box,
  Col,
  Icon,
  SelectDates,
  RadioButton,
  RadioGroup,
  Row,
  Text,
} from '@cubeyou-team/hx-react-components';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { isCustomTimeframe } from '../../../../utils/misc';

const StyledConversationAdvancedOptions = styled.div`
  background-color: ${props => props.theme.colors.light_dark};
`;

const ConversationAdvancedOptions = ({
  conversation,
  query,
  onAudienceTimeframeChange,
}) => {
  const { audience_timeframe } = query;
  const isCustom = isCustomTimeframe(audience_timeframe);
  const [selectedStartDate, setSelectedStartDate] = useState(
    (isCustom && audience_timeframe.split(',')[0]) ||
      format(new Date().getTime(), 'yyyy-MM-dd')
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    (isCustom && audience_timeframe.split(',')[1]) ||
      format(new Date().getTime(), 'yyyy-MM-dd')
  );

  const handleOnRadioChange = useCallback(
    value => {
      let audienceTimeframe = value;
      if (value === 'custom') {
        audienceTimeframe = `${selectedStartDate},${selectedEndDate}`;
      }
      onAudienceTimeframeChange(audienceTimeframe);
    },
    [onAudienceTimeframeChange, selectedStartDate, selectedEndDate]
  );

  return (
    <React.Fragment>
      <StyledConversationAdvancedOptions>
        <Box pX="large" pY="medium">
          <Row>
            <Col span={12}>
              <Box pB="medium">
                <Row halign="left" valign="middle" gutter="small">
                  <Col span="auto">
                    <Icon icon="calendar" size="medium" />
                  </Col>
                  <Col span="auto">
                    <Text size="xbody" variant="dark" weight="bold">
                      Timed Interest
                    </Text>
                  </Col>
                </Row>
              </Box>
            </Col>
            <Col span={12}>
              <RadioGroup
                name="timeframe"
                onChange={({ target: { value } }) => handleOnRadioChange(value)}
                selected={(isCustom && 'custom') || audience_timeframe}
                size="standard"
              >
                {conversation.timeframes.map((timeframe, index) => (
                  <React.Fragment key={`timeframe-${index}`}>
                    <RadioButton
                      key={`timeframe-${index}`}
                      value={timeframe.id}
                    >
                      <Text size="xbody" variant="dark" weight="semi-bold">
                        {timeframe.label}
                      </Text>
                    </RadioButton>
                    {timeframe.id === 'custom' && (
                      <Box pL="large" pB="large">
                        <div
                          style={{
                            maxWidth: '300px',
                          }}
                        >
                          <SelectDates
                            dropdownPosition="right"
                            onSaveDates={dates => {
                              setSelectedStartDate(dates[0]);
                              setSelectedEndDate(dates[1]);
                              onAudienceTimeframeChange(
                                `${dates[0]},${dates[1]}`
                              );
                            }}
                            options={{ selectedStartDate, selectedEndDate }}
                            label=""
                            calendarChoice="range"
                            selectedStartDate={selectedStartDate}
                            selectedEndDate={selectedEndDate}
                            minYear={2020}
                            maxYear={new Date().getFullYear()}
                            blockDates="future"
                            disabled={!isCustom}
                            placeholder={' '}
                            format={'YYYY-MM-DD'}
                          />
                        </div>
                      </Box>
                    )}
                  </React.Fragment>
                ))}
              </RadioGroup>
            </Col>
          </Row>
        </Box>
      </StyledConversationAdvancedOptions>
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  conversation: state.conversation,
});

export default connect(mapStateToProps)(ConversationAdvancedOptions);
